export default __webpack_public_path__ + "static/media/gowithflow.afebd235.png";